import React from "react";
import FeatureCard from "../../../common/feature-card/FeatureCard";
import { useTranslation } from "react-i18next";
import { svgs } from "../../../../core/constants/svgs";

const CategoryBasedTypes = ({
  data,
  img,
  onLookupClick,
  isVisible = true,
  refomulateAutobio = false,
}) => {
  const { t } = useTranslation();
  const key = "category_based_types";

  const groupedItems = React.useMemo(() => {
    let validItems = data?.[key]?.filter((item) => item?.group_id !== null);
    if (refomulateAutobio) {
      validItems = validItems.slice(2);
    }

    const groups = {};
    validItems?.forEach((item) => {
      const groupId = item.group_id;
      if (!groups[groupId]) groups[groupId] = [];
      groups[groupId].push(item);
    });

    const nonEmptyGroups = {};
    Object.entries(groups).forEach(([groupId, groupItems]) => {
      const hasOptions = groupItems.some((item) => !item.is_group_title);
      if (hasOptions) {
        nonEmptyGroups[groupId] = groupItems;
      }
    });

    return nonEmptyGroups;
  }, [data, refomulateAutobio]);

  const groupRefs = React.useRef({});

  Object.keys(groupedItems).forEach((groupId) => {
    if (!groupRefs.current[groupId]) {
      groupRefs.current[groupId] = React.createRef();
    }
  });

  const scrollToNextGroup = (currentGroupId) => {
    const groupIds = Object.keys(groupedItems).sort();
    const currentIndex = groupIds.indexOf(currentGroupId.toString());

    if (currentIndex >= 0 && currentIndex < groupIds.length - 1) {
      const nextGroupId = groupIds[currentIndex + 1];
      const nextRef = groupRefs.current[nextGroupId];
      if (nextRef?.current) {
        nextRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      }
    }
  };

  return (
    <div
      style={
        isVisible
          ? { height: "auto", visibility: "visible" }
          : { height: "0px", visibility: "hidden" }
      }
    >
      {Object.keys(groupedItems).length > 0 && (
        <div id={key + "-title-id"}>
          {/* <div className="row justify-content-center">
            <div className="col-lg-8 col-md-6 mb-3">
              <h4 className="section-desc">
                {t("how_do_you_want_to_organize_your_chapters")}?
              </h4>
            </div>
            <div className="col-lg-8 col-md-6" />
          </div> */}

          {Object.entries(groupedItems).map(([groupId, items]) => {
            const titleItem = items.find((item) => item.is_group_title);
            const optionItems = items.filter((item) => !item.is_group_title);

            return (
              <div
                className="row mb-4"
                key={`group-${groupId}`}
                ref={groupRefs.current[groupId]}
              >
                {titleItem && (
                  <div className="row">
                    <div className="col-lg-8 col-md-6 mb-3">
                      <h4 className="section-desc">{titleItem.name}</h4>
                    </div>
                    <div className="col-lg-8 col-md-6" />
                  </div>
                )}

                {optionItems.map((item, index) => {
                  return (
                    <FeatureCard
                      key={`${key}-${groupId}-${index}`}
                      onClick={() => {
                        onLookupClick(key, item)();
                        scrollToNextGroup(groupId);
                      }}
                      name={item.name}
                      description={item.description}
                      is_selected={item.is_selected}
                      showArrow={false}
                      variant="general-categories-options"
                    />
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CategoryBasedTypes;
